/* eslint-disable */
import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // Exact match for submenu: path must equal base or start with base + "/" (so "careers" doesn't match "careers-job-details")
  // Handles dynamic segments like "careers-job-details/:jobId" by matching on the static prefix only
  const isSubmenuActive = (layout, routePath, subPath) => {
    const pathname = location.pathname;
    const baseSubPath = subPath.split("/").filter((p) => !p.startsWith(":")).join("/");
    const fullBasePath = `${layout}/${routePath}/${baseSubPath}`;
    return pathname === fullBasePath || pathname.startsWith(fullBasePath + "/");
  };

  // Track open/closed state for submenus by index
  const [openMap, setOpenMap] = useState({});

  // Ensure correct default open state on route change
  useEffect(() => {
    const next = {};
    routes.forEach((route, idx) => {
      const hasSubmenu = Array.isArray(route.submenu) && route.submenu.length > 0;
      if (hasSubmenu) {
        const isAnySubActive = route.submenu.some((s) =>
          isSubmenuActive(route.layout, route.path, s.path)
        );
        next[idx] = isAnySubActive; // open only if a child is active
      }
    });
    setOpenMap(next);
  }, [location.pathname, routes]);

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (!(route.layout === "/admin" || route.layout === "/auth")) return null;

      const hasSubmenu = Array.isArray(route.submenu) && route.submenu.length > 0;
      const locationPath = location.pathname;

      if (hasSubmenu) {
        const isOpen = !!openMap[index];
        const isAnySubActive = route.submenu.some((s) => isSubmenuActive(route.layout, route.path, s.path));
        return (
          <div key={index} className="mb-1">
            <button
              type="button"
              aria-expanded={isOpen}
              className="relative mb-1 flex w-full items-center px-8 py-2 text-left hover:cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setOpenMap((prev) => ({ ...prev, [index]: !prev[index] }));
              }}
            >
              <span
                className={`${
                  isAnySubActive
                    ? "font-bold text-[#45A2E8] dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.icon ? route.icon : <DashIcon />}
              </span>
              <p
                className={`leading-1 ml-4 flex ${
                  isAnySubActive
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.name}
              </p>
              <svg
                className={`ml-auto h-4 w-4 transform text-gray-400 transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
              {/* {isAnySubActive ? (
                <div className="absolute right-0 top-1 h-9 w-1 rounded-lg bg-[#45A2E8] dark:bg-brand-400" />
              ) : null} */}
            </button> 
            <ul
              id={`submenu-${index}`}
              data-open={isOpen ? "true" : "false"}
              style={{ maxHeight: isOpen ? "1000px" : "0px" }}
              className="ml-12 overflow-hidden transition-all duration-300 ease-in-out"
            >
              {route.submenu.map((sub, sidx) => {
                const subActive = isSubmenuActive(route.layout, route.path, sub.path);
                return (
                  <li key={sidx} className="">
                    <Link to={`${route.layout}/${route.path}/${sub.path}`} className="block py-2 pr-4">
                      <span
                        className={`${
                          subActive
                            ? "font-semibold text-navy-700 dark:text-white"
                            : "text-gray-600"
                        }`}
                      >
                        {sub.name}
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      }

      return (
        <Link key={index} to={route.layout + "/" + route.path}>
          <div className="relative mb-3 flex hover:cursor-pointer">
            <li
              className="my-[3px] flex cursor-pointer items-center px-8"
              key={index}
            >
              <span
                className={`${
                  activeRoute(route.path) === true
                    ? "font-bold text-[#45A2E8] dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.icon ? route.icon : <DashIcon />} {" "}
              </span>
              <p
                className={`leading-1 ml-4 flex ${
                  activeRoute(route.path) === true
                    ? "font-bold text-navy-700 dark:text-white"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.name}
              </p>
            </li>
            {activeRoute(route.path) ? (
              <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-[#45A2E8] dark:bg-brand-400" />
            ) : null}
          </div>
        </Link>
      );
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
